<mat-dialog-content class="p3rem content-details">
    <div
        [attr.ga-event-id]="
            info?.sub_title +
            '_x_button_partnership_popup_click'
        "
        ga-event-category="Partnership Popup Button"
        [attr.ga-event-label]="
            info?.sub_title +
            ' X Button Partnership Popup Click'
        "
        ga-track="track"
        (click)="closeDialog()"
        class="tw-float-right tw-cursor-pointer tw-text-[20px]"
    >
        X
    </div>
    <div
        class="md:tw-hidden tw-mt-[25px] tw-flex tw-flex-col tw-gap-[20px] tw-mb-[20px]"
    >
        <img
            alt="img"
            src="{{ info?.partnershipImageUrl }}"
            class="tw-w-full tw-h-auto"
        />
        <div class="tw-flex tw-flex-col tw-gap-[20px] tw-p-[20px]">
            <div
                class="tw-text-[#4B6EEC] tw-font-semibold tw-text-[16px]"
                [innerHTML]="info?.main_title"
            ></div>
            <div
                class="tw-text-[#123D72] tw-font-bold tw-text-[30px]"
                [innerHTML]="info?.sub_title"
            ></div>
            <div class="tw-flex tw-flex-row">
                <img
                    alt="img"
                    src="/assets/images/important.png"
                    class="tw-w-[15px] tw-h-[15px] tw-mt-[3px]"
                />
                <span class="tw-ml-[10px]">{{
                    "CAMPAIGN_PARTNERSHIP_PAGE.POPUP_MSG" | translate
                }}</span>
            </div>
        </div>
        <button
            [attr.ga-event-id]="
                info?.sub_title +
                '_button_partnership_popup_click'
            "
            ga-event-category="Partnership Popup Button"
            [attr.ga-event-label]="
                info?.sub_title +
                ' Button Partnership Popup Click'
            "
            ga-track="track"
            class="tw-text-white tw-text-[18px] tw-font-bold tw-bg-[#FF7B00] tw-py-[1.1rem] tw-basis-[100%] lg:tw-basis[50%] tw-whitespace-nowrap tw-rounded-[32px] tw-px-[2.2rem] 2xl:tw-px-[2.5rem] tw-w-auto"
            type="submit"
            (click)="openURL(info?.partnershipUrl)"
        >
            {{ info?.cta }}
        </button>
    </div>
    <div
        class="tw-hidden md:tw-flex tw-mt-[25px] tw-flex tw-flex-row tw-gap-[20px] tw-mb-[20px]"
    >
        <img
            alt="img"
            src="{{ info?.partnershipImageUrl }}"
            class="tw-w-[40%] tw-h-auto"
        />
        <div class="tw-flex tw-flex-col tw-gap-[20px]">
            <div
                class="tw-text-[#4B6EEC] tw-font-semibold tw-text-[16px]"
                [innerHTML]="info?.main_title"
            ></div>
            <div
                class="tw-text-[#123D72] tw-font-bold tw-text-[30px]"
                [innerHTML]="info?.sub_title"
            ></div>
            <div class="tw-flex tw-flex-row">
                <img
                    alt="img"
                    src="/assets/images/important.png"
                    class="tw-w-[15px] tw-h-[15px] tw-mt-[3px]"
                />
                <span class="tw-ml-[10px] tw-text-[12px] tw-pr-[75px]">{{
                    "CAMPAIGN_PARTNERSHIP_PAGE.POPUP_MSG" | translate
                }}</span>
            </div>
            <button
                [attr.ga-event-id]="
                    info?.sub_title +
                    '_button_partnership_popup_click'
                "
                ga-event-category="Partnership Popup Button"
                [attr.ga-event-label]="
                    info?.sub_title +
                    ' Button Partnership Popup Click'
                "
                ga-track="track"
                *ngIf="info?.cta"
                class="tw-w-[42%] tw-text-white tw-text-[16px] tw-font-bold tw-bg-[#FF7B00] tw-py-[1rem] tw-whitespace-nowrap tw-rounded-[32px]"
                type="submit"
                (click)="openURL(info?.partnershipUrl)"
            >
                {{ info?.cta }}
            </button>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div
        class="tw-mt-[20px] tw-whitespace-pre-line tw-text-[#123D72] tw-text-[18px] tw-p-[20px] md:tw-p-0"
        [innerHTML]="info?.description"
    ></div>
</mat-dialog-content>
